if (!customElements.get('animated-flower')) {
  class AnimatedFlower extends HTMLElement {
    constructor() {
      super();
      this.control = this.querySelector('.flower');
      // A <button> (the standalone decorative flower) toggles open/closed
      // on click, since it has nowhere else for a click to go. A <a> (the
      // category petals) only opens when category-flower-filter.js calls
      // setSelected() on click — no hover/focus preview, animation is
      // click-only.
      this.isToggle = this.control.tagName === 'BUTTON';
      this.isAnimating = false;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.isToggle) {
        this.control.addEventListener('click', this.onToggleClick.bind(this));
      }

      this.control.addEventListener('animationend', this.onZoomEnd.bind(this));
    }

    onToggleClick() {
      if (this.isAnimating) return;

      const opening = !this.control.classList.contains('is-open');
      this.control.classList.toggle('is-open', opening);
      this.control.setAttribute('aria-pressed', String(opening));
      this.playZoom();
    }

    setOpen(opening) {
      if (this.control.classList.contains('is-open') === opening) return;
      this.control.classList.toggle('is-open', opening);
      this.playZoom();
    }

    // Called by category-flower-filter.js: exactly one petal in the row is
    // selected at a time, staying open until another one is picked.
    setSelected(selected) {
      this.control.classList.toggle('is-selected', selected);
      this.setOpen(selected);
    }

    playZoom() {
      if (this.prefersReducedMotion) return;

      this.isAnimating = true;
      // Remove-reflow-add so a rapid repeat trigger restarts the animation
      // from scratch instead of being ignored by the browser as a no-op
      // class change.
      this.control.classList.remove('is-zooming');
      void this.control.offsetWidth;
      this.control.classList.add('is-zooming');
    }

    onZoomEnd(event) {
      if (event.target !== this.control) return;
      this.control.classList.remove('is-zooming');
      this.isAnimating = false;
    }
  }

  customElements.define('animated-flower', AnimatedFlower);
}
